module.exports = __webpack_public_path__ + "img/northern-marianas-islands.dda8d9b6.png";